import { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import api from "@/lib/api";
import { useT } from "@/i18n/I18nContext";
import MovixLogo from "@/components/MovixLogo";
import { CheckCircle2, Loader2, ArrowLeft } from "lucide-react";

export default function PaymentSuccess() {
  const { t, fmtCurrency } = useT();
  const loc = useLocation();
  const sessionId = new URLSearchParams(loc.search).get("session_id");
  const [status, setStatus] = useState(null);
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) return;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/billing/checkout-status/${sessionId}`);
        setStatus(data);
        if (data.payment_status !== "paid" && data.status !== "expired" && attempts < 8) {
          timer = setTimeout(() => setAttempts((a) => a + 1), 2000);
        }
      } catch {
        if (attempts < 5) timer = setTimeout(() => setAttempts((a) => a + 1), 2000);
      }
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId, attempts]);

  const paid = status?.payment_status === "paid";

  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center p-6">
      <div className="absolute top-6 left-6"><MovixLogo variant="light" showTagline={false} size="md" /></div>
      <div className="max-w-md w-full text-center space-y-6">
        {paid ? (
          <>
            <CheckCircle2 className="w-20 h-20 mx-auto text-[#25D366]" />
            <h1 className="font-display font-black text-4xl tracking-tighter">{t("billing.paymentSuccess")}</h1>
            <p className="text-white/70">{t("billing.paymentSuccessMsg")}</p>
            {status?.amount_total != null && (
              <div className="border border-white/10 p-6 bg-white/5">
                <div className="overline text-white/60 mb-2">{t("common.amount")}</div>
                <div className="font-display font-black text-3xl">{fmtCurrency((status.amount_total || 0) / 100)}</div>
              </div>
            )}
          </>
        ) : (
          <>
            <Loader2 className="w-12 h-12 mx-auto animate-spin text-[#F5A623]" />
            <p className="text-white/70">{t("billing.checkingStatus")}</p>
          </>
        )}
        <Link to="/" className="inline-flex items-center gap-2 px-5 py-2 border border-white/20 hover:bg-white/10 transition-colors">
          <ArrowLeft className="w-4 h-4" /> {t("billing.backToApp")}
        </Link>
      </div>
    </div>
  );
}
